<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M18.8255 8.88552L18.7107 8.78832L18.6138 8.90341L12.2659 16.4454L9.17592 13.8675L9.06193 13.7724L8.96565 13.8854L7.88582 15.1527L7.78773 15.2678L7.90367 15.365L12.3797 19.115L12.4943 19.211L12.5907 19.0967L20.1147 10.1731L20.2112 10.0586L20.0969 9.96191L18.8255 8.88552Z"
    fill="#006943"
    stroke="#006943"
    stroke-width="0.3"
  />
</svg>
